import React from 'react';
import { TrendingUp, Clock, Sparkles } from 'lucide-react';

export const Context = () => {
  const reasons = [
    {
      icon: TrendingUp,
      title: 'Mejorar la experiencia de usuarios',
      description: 'Las personas esperan servicios que aporten comodidad y bienestar.'
    },
    {
      icon: Clock,
      title: 'Facilitar pausas durante la jornada',
      description: 'Espacios de descanso ayudan a mejorar productividad.'
    },
    {
      icon: Sparkles,
      title: 'Servicios rápidos dentro del espacio',
      description: 'Snacks, bebidas y café sin salir del edificio.'
    }
  ];

  return (
    <section id="contexto" className="py-12 md:py-16 bg-[#F8F5F0] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#CFAE70]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#003847]/5 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#003847]/10 text-[#003847] text-sm font-semibold rounded-full mb-4">
            Contexto
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#003847] mb-6">
            ¿Por qué cada vez más organizaciones instalan vending en sus espacios?
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#003847] to-[#004555] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-[#003847] mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
